import React from "react";

/**
 * PlexSpinner — animated 3-ball loader using the Plex brand cluster.
 *
 * Visual design (per user direction):
 *   - 3 circles match the brand wordmark's ball cluster:
 *       orange       (#f38e00, largest)
 *       red-orange   (#e83e1c, medium)
 *       magenta      (#c30055, smallest)
 *   - Each ball orbits a central axis with continuous rotation.
 *   - The orbit RADIUS oscillates on a sine wave (widens out / pulls in)
 *     so the cluster breathes as it spins. Each ball has a different
 *     phase offset so the breathing reads as organic, not lockstep.
 *
 * Pure CSS animation — no JS timers, no render churn during streaming.
 */

// `role`: "status" announces it; an icon repeated down a list (ActiveAgentIcon) is an "img".
const PlexSpinner = ({ size = 36, ariaLabel = "Loading", role = "status" }) => (
  <span
    className="plex-spinner"
    role={role}
    aria-label={ariaLabel}
    style={{ width: size, height: size }}
    data-testid="v2-plex-spinner"
  >
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden="true">
      {/* Shift origin to SVG center so the orbit rotation rotates around (0,0)
          which is now the center. Avoids transform-origin browser quirks. */}
      <g transform="translate(50, 50)">
        {/* Each ball: outer <g> rotates around the center; inner <g>
            translates outward with oscillating distance. Different
            starting angle + different animation-delay per ball. */}
        <g className="plex-spinner__orbit plex-spinner__orbit--1">
          <g className="plex-spinner__radius plex-spinner__radius--1">
            <circle cx="0" cy="0" r="13" fill="#f38e00" />
          </g>
        </g>
        <g className="plex-spinner__orbit plex-spinner__orbit--2">
          <g className="plex-spinner__radius plex-spinner__radius--2">
            <circle cx="0" cy="0" r="8" fill="#e83e1c" />
          </g>
        </g>
        <g className="plex-spinner__orbit plex-spinner__orbit--3">
          <g className="plex-spinner__radius plex-spinner__radius--3">
            <circle cx="0" cy="0" r="5" fill="#c30055" />
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default PlexSpinner;
